// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.siOu3{align-items:center;color:inherit;display:flex;padding:0 0 10px;text-decoration:none}.ivA6q{color:#0b40a0;font-family:jaf-domus,sans-serif;font-size:19.2px;font-size:1.2rem;font-weight:300;line-height:1.334;margin:20px 0}.oCWJW{align-items:center;border:1.5px solid #0b40a0;border-radius:50%;display:inline-flex;height:40px;justify-content:center;margin-right:10px;width:40px}.q587L{align-items:center;display:flex;justify-content:center;margin:20px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"courseListItem": "siOu3",
	"coursesList": "ivA6q",
	"bookIcon": "oCWJW",
	"noCoursesText": "q587L"
};
module.exports = ___CSS_LOADER_EXPORT___;
